import { createContext, FC, ReactNode, useContext, useRef } from "react";

import { logger } from "@moodys/mdc-frontend.services.logger";

import { footerStyles as styles } from "./Footer.styles";

const noProviderError = {
  error: "No FooterContextProvider provider in tree",
};

const FooterContext = createContext<{
  clickOneTrustButton: () => void;
}>({
  clickOneTrustButton: () => {
    logger.error(noProviderError);
  },
});

export const FooterContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const oneTrustButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <FooterContext.Provider
      value={{
        clickOneTrustButton: () => oneTrustButtonRef.current?.click(),
      }}
    >
      {children}
      <button
        id="ot-sdk-btn"
        className="ot-sdk-show-settings"
        css={styles.oneTrustButton}
        ref={oneTrustButtonRef}
        type="button"
      />
    </FooterContext.Provider>
  );
};

export const useClickOneTrustButton = () => useContext(FooterContext);
